import { String } from "./Strings";

/**
 * The three phases of the "Plan Your Financial Future" journey, in order.
 *
 * `routes` lists every screen that belongs to a phase, referenced through
 * String.navigations so the paths stay defined in one place. The active phase is
 * derived from the current route rather than passed in per screen, because the
 * existing LinearProgressBar `stepNumber` is a 4-step scale in which step 2
 * covers both the income screens and every future-goal screen.
 */
export const JourneyStepsArray = [
  {
    id: "incomeAndSavings",
    stepNumber: 1,
    label: String.journeySteps.incomeAndSavings,
    routes: [String.navigations.financialquestion],
  },
  {
    id: "futureGoals",
    stepNumber: 2,
    // Already defined for the Future Goals screen itself, so it is reused here.
    label: String.Retirement.FutureGoal.Title,
    routes: [
      String.navigations.goal,
      String.navigations.childquestion,
      String.navigations.retirementgoal,
      String.navigations.investmentgoal,
    ],
  },
  {
    id: "financialSnapshot",
    stepNumber: 3,
    label: String.journeySteps.financialSnapshot,
    routes: [
      String.navigations.fetchinfo,
      String.navigations.webview,
      String.navigations.financialsnapshot,
    ],
  },
];

// Trailing slashes and casing vary depending on how a screen was reached.
const normalisePath = (pathname) =>
  (pathname || "").toLowerCase().replace(/\/+$/, "") || "/";

/**
 * Step number of the phase the given route belongs to, or 0 when the route is
 * outside the journey (onboarding, portfolio, dashboards), in which case the
 * stepper is not rendered at all.
 */
export const getActiveStepNumber = (pathname) => {
  const current = normalisePath(pathname);
  const activeStep = JourneyStepsArray.find((step) =>
    step.routes.some((route) => normalisePath(route) === current),
  );
  return activeStep ? activeStep.stepNumber : 0;
};
